"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha256Salt = void 0;
const sha256_1 = __importDefault(require("@cryptography/sha256"));
const sha256Salt = (str, salt) => (0, sha256_1.default)(`${str}${salt}`, 'hex');
exports.sha256Salt = sha256Salt;
//# sourceMappingURL=sha256Salt.js.map